import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#BCD35F'
        },
        secondary: {
            main: '#C87137'
        },
        success: {
            main: '#88AA00'
        },
        info: {
            main: '#5fbcd3'
        }

    }
})